import ExternalTicketingClientTicketType from 'src/models/external-ticketing/ExternalTicketingClientTicketType'
import OauthApplication from 'src/models/external-ticketing/OauthApplication'
import Model, { encoders, ID, MODEL_LEVEL } from 'src/models/Model'
import Site from 'src/models/site/Site'

export default class ExternalTicketingClient extends Model {
  static name = 'ExternalTicketingClient'

  static versioned = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Site]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      oauthApplication: {
        type: OauthApplication,
        default: null,
        encode: encoders.hasOne,
        output: true
      },
      enabled: {
        type: Boolean,
        default: false
      },
      chargeBookingFee: {
        type: Boolean,
        default: false
      },
      enableDynamicTicketPricing: {
        type: Boolean,
        default: false
      },
      numberOfFutureWeeksToInclude: {
        type: Number,
        default: 24
      },
      externalTicketingClientTicketTypes: {
        type: [ExternalTicketingClientTicketType],
        reference: true,
        allowDestroy: true,
        acceptsNestedAttributes: true
      },
      site: {
        type: Site,
        default: null,
        encode: encoders.hasOne
      }
    }
  }
}
